import './App.css';
import 'moment/locale/ko'
import router from './router'
import { RecoilRoot } from 'recoil'
import { RouterProvider } from "react-router-dom"
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { ConfirmProvider } from './plugins/useConfirm';
import { BedDataProvider } from './context/BedDataContext';

function App() {
  return (
    <RecoilRoot>
      <BedDataProvider>
      <ConfirmProvider>
        <RouterProvider router={router}>
          
        </RouterProvider>
        <ToastContainer
            className="toast-container"
            position={'bottom-center'}
            autoClose={4000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            pauseOnFocusLoss={false}
            rtl={false}
            limit={1}
            pauseOnHover={false}
            transition={Slide}
            closeButton={false}
          />
      </ConfirmProvider>
      </BedDataProvider>
    </RecoilRoot>
  );
}

export default App;
